import * as React from 'react';
import NextHead from 'next/head';
import { useRouter } from 'next/router';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

import { TLD } from '@packages/common';

export const fbPages = {
  [TLD.DE]: '88292693246',
  [TLD.NL]: '88292693246',
  [TLD.FR]: '111794729228134',
};

const seoLanguageAndCountry = {
  [TLD.DE]: 'de-de',
  [TLD.NL]: 'nl-nl',
  [TLD.FR]: 'fr-fr',
};

export interface HeadProps {
  title: string;
  description: string;
  ogTitle: string;
  ogDescription?: string;
  ogImageUrl?: string;
  canonicalUrl?: string;
  robots?: string;
}

const APP_TLD = getPublicRuntimeConfig('APP_TLD');
const PUBLIC_DOMAIN = getPublicRuntimeConfig('PUBLIC_DOMAIN');
const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

export const Head: React.FC<HeadProps> = ({
  title,
  description,
  ogTitle,
  ogDescription,
  ogImageUrl,
  canonicalUrl,
  robots = 'index,follow',
}) => {
  const { asPath } = useRouter();

  const location = asPath.split('?')[0]; // TODO: make this hero filter compatible
  const fbPageId = fbPages[APP_TLD];
  const siteName = `www.${PUBLIC_DOMAIN}.${APP_TLD}`;

  const canonicalHref = (canonicalUrl || `https://${siteName}${location}`).replace(/\/+$/i, '');

  return (
    <NextHead>
      <title>{title}</title>
      <meta name="moebel:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:site_name" content={siteName}></meta>
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImageUrl || `${ASSETS_URL}/opengraph/ogtag_fallback.png`} />
      <meta property="og:image:width" content="1200px" />
      <meta property="og:image:height" content="600px" />
      <meta property="fb:pages" content={fbPageId} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalHref} />
      <link rel="alternate" href={canonicalHref} hrefLang={seoLanguageAndCountry[APP_TLD]} />
    </NextHead>
  );
};
